module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/reverb-logo-add97ce73ef7daa31d6b2b48bf168bde.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/reverb-logo.svg
// module id = QWag
// module chunks = 24